import { isEmpty, toNumber } from 'lodash';
import { useContext, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { AuthDataProvider } from 'src/components/authProvider';
import { QueryOperator } from 'src/constants';
import {
  useGetLocation,
  useGetScheduleDayparts,
  useParamQuery,
  useViewChannels,
} from 'src/hooks';
import { checkIsDefaultLocationGroup } from 'src/hooks/api/locations/helper';
import { useApiErrorNavigator } from 'src/hooks/navigation';

export const useLocationTimingPage = (locationCode = '') => {
  const { userRole } = useContext(AuthDataProvider);
  const { getParamsValue, onChangeParams } = useParamQuery();
  const locationGroupId = toNumber(getParamsValue('groupID').join());

  const {
    data: location,
    isLoading: isLocationLoading,
    error,
  } = useGetLocation(locationCode, userRole);
  const { data: channels = [], isLoading: isLoadingChannels } =
    useViewChannels();

  const isDefaultLocationGroup = checkIsDefaultLocationGroup(location);

  useApiErrorNavigator(error);

  const formMethods = useForm({
    values: {
      location: location,
    },
  });

  useEffect(() => {
    const isOverridePage = window.location.href.includes('/override');

    if (!isEmpty(location) && !locationGroupId && !isOverridePage) {
      onChangeParams(
        'groupID',
        String(location.location_group_id[0]),
        true,
        QueryOperator.OR,
        false,
      );
    }
  }, [location, locationGroupId, onChangeParams]);

  const { data: locGroupDayparts, isLoading: isLoadingLocGroupDayparts } =
    useGetScheduleDayparts(
      [`location_group_id=${locationGroupId}`],
      Boolean(locationGroupId),
    );

  const channelsData = location?.locationGroups?.filter((secondItem) => {
    return channels.some(
      (firstItem) => firstItem.channel_name === secondItem.channel_name,
    );
  });

  const updateSelectedLocationGroup = (value: unknown) => {
    onChangeParams('groupID', value as string, true, QueryOperator.OR, false);
  };

  return {
    formMethods,
    isLoadingChannels,
    isLocationLoading,
    channelsData,
    locGroupDayparts,
    isLoadingLocGroupDayparts,
    updateSelectedLocationGroup,
    selectedLocationGroup: location?.locationGroups?.find(
      (group) => group.id === locationGroupId,
    ),
    isDefaultLocationGroup,
    locationData: location,
  };
};
